import styled, { css } from 'styled-components';
import { Heading, IconButton } from '@alefeducation/ui-elements-library-core';
import {
  RedoAlt,
  Filter,
  TrashSolid,
} from '@alefeducation/ui-elements-library-icons';
import React, { useState } from 'react';
import { FilterRow } from './FilterRow';
import { useAvatarUploadContext } from './context';
import { UPLOAD_HISTORY } from '../../utils/constants';

type Props = {
  onRefresh: () => void;
  showFilter: boolean;
  toggleFilter: (showFilter: boolean) => void;
};

const TableActionsHeader = (props: Props) => {
  const [showFilter, setShowFilter] = useState(props.showFilter);
  const { resetFilters, onAvatarDelete, selectedAvatarFileIds } =
    useAvatarUploadContext();

  const toggleFilter = () => {
    props.toggleFilter(!showFilter);
    setShowFilter(!showFilter);
    if (showFilter) {
      resetFilters();
    }
  };

  const onRefresh = () => {
    if (showFilter) {
      toggleFilter();
    }
    props.onRefresh();
  };

  if (selectedAvatarFileIds.length > 0) {
    return (
      <StyledContainer
        data-testid="table-action-header"
        style={{ alignItems: 'flex-start' }}
      >
        <IconButton
          onClick={() => {
            onAvatarDelete([...selectedAvatarFileIds]);
          }}
          size="large"
          tooltipContent="Delete"
          data-testid="delete-all-delete-icon"
        >
          <TrashSolid />
        </IconButton>
      </StyledContainer>
    );
  }

  return (
    <StyledContainer data-testid="table-action-header">
      <StyledTopContent>
        <Heading variant="heading-medium" weight="bold">
          {UPLOAD_HISTORY}
        </Heading>
        <StyledActions>
          <IconButton
            className={showFilter ? 'active' : ''}
            data-testid="icon-filter-button"
            onClick={toggleFilter}
            size="small"
            tooltipContent=""
          >
            <Filter />
          </IconButton>

          <IconButton
            data-testid="icon-refresh-button"
            onClick={onRefresh}
            size="small"
            tooltipContent="Refresh Data"
          >
            <RedoAlt />
          </IconButton>
        </StyledActions>
      </StyledTopContent>

      {showFilter && <FilterRow />}
    </StyledContainer>
  );
};

export default TableActionsHeader;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  row-gap: 32px;
  padding: 16px 16px 16px 24px;
  min-height: 72px;

  column-gap: 16px;
`;

const StyledTopContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 16px;

  .active {
    ${({
      theme: {
        colors: { interactive },
      },
    }) => css`
      border-color: ${interactive[100]};
      color: ${interactive[100]};
    `}
  }
`;
